<template>
  <a-card :bordered="false" class="m-t-10" :hidden='historyLength == 1'>
    <a-button class="mr15" size='small' @click="()=>{$router.go(-1)}" >
      <LeftOutlined />返回
    </a-button>
    <span class="card_title">出库单详情</span>
  </a-card>
  <!--startprint-->
  <a-card :bordered="false">
    <div class="s_flex_bian">
      <a-descriptions title="出库单操作" class="width80" :column='5'>
        <a-descriptions-item label="订单状态">{{orderData.out_warehousing_status_text}}</a-descriptions-item>
        <a-descriptions-item label="出库单号" :span='2'>{{orderData.out_warehousing_sn}}</a-descriptions-item>
        <a-descriptions-item label="发货仓库" :span='2'>{{orderData.warehouse_position_name}}</a-descriptions-item>
        <a-descriptions-item label="备注" :span='5'>{{orderData.remark || '-'}}</a-descriptions-item>
      </a-descriptions>
      <!-- <img class="width-150 height-150" v-if='orderData.out_warehousing_status == 1' src="@/assets/images/user.png" alt=""> -->
      <!-- 二维码 -->
      <div id="qrcode"  v-show='orderData.out_warehousing_status == 1'></div> 
    </div>
    <div class="m-t-10 p-b-10">
      <!-- <a-button class="width-100 m-r-20" block @click='closeOrder' v-if='orderData.out_warehousing_status == 1 || orderData.out_warehousing_status == 2'>关闭订单</a-button> -->
      <a-button class="width-100" block type="primary" @click="printOrder"  v-if='orderData.out_warehousing_status == 1'> 打印</a-button>
    </div>
    <a-descriptions title="创建人详情" :column='1' class="m-t-20">
      <a-descriptions-item label="创建人">{{orderData.create_role_name}}</a-descriptions-item>
      <a-descriptions-item label="联系电话">{{orderData.create_role_phone}}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="出库单详情" :column='1' class="m-t-20">
      <a-descriptions-item label="发货信息">{{orderData.from}}</a-descriptions-item>
      <a-descriptions-item label="收货信息">{{orderData.to}}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{orderData.created_at}}</a-descriptions-item>
      <a-descriptions-item label="物流公司" v-if='orderData.out_warehousing_status == 2 || orderData.out_warehousing_status == 3'>{{orderData.logistics_name || '-'}}</a-descriptions-item>
      <a-descriptions-item label="物流单号" v-if='orderData.out_warehousing_status == 2 || orderData.out_warehousing_status == 3'>{{orderData.logistics_code || '-'}}</a-descriptions-item>
      <a-descriptions-item label="出库时间" v-if='orderData.out_warehousing_status == 2 || orderData.out_warehousing_status == 3'>{{orderData.out_warehousing_time}}</a-descriptions-item>
      <a-descriptions-item label="签收时间" v-if='orderData.out_warehousing_status == 3'>{{orderData.signing_time}}</a-descriptions-item>
    </a-descriptions>
    <div class="fz-16 s_font_b m-t-20">商品详情</div>
    <a-table class='m-t-25' :pagination='false' :loading='loading' bordered rowKey='product_sn' :columns='columns'
      :data-source='orderData.product'>
      <template v-slot:gift_name="{ record }">
        <a-card-meta>
          <template #avatar>
            <img :src="info.picdomain+'/'+(record.product_image)" alt="" style="width:50px;height:50px">
          </template>
          <template #description>
            <p class="s_omit2" style="width: 320px;">{{record.product_name}}</p>
          </template>
        </a-card-meta>
      </template>
      <!-- <template v-slot:action="{ record }">
        <a-button type="link" @click='showCode = true;goodsItem = record' >查看出货二维码</a-button>
      </template> -->
    </a-table>
  </a-card>
  <!--endprint-->
  <a-modal :keyboard="false" title="出货二维码" :width='1300' centered v-model:visible="showCode" destroyOnClose :footer='null'>
    <shippingCode :id='goodsItem.product_id' :showLast='true' :sn='$route.query.id' :sku_sn='goodsItem.product_sku_sn' type='outbound'></shippingCode>
  </a-modal>
</template>

<script>
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs, h } from "vue";
  import { message } from "ant-design-vue";
  import store from "@/store";
  import shippingCode from '../../components/shippingCode.vue' 
  import { getOutWarehousingMore,closeRefundOrder }  from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  import { qrcanvas } from 'qrcanvas';
  export default {
    components: { LeftOutlined,shippingCode },
    setup() {
      const state = reactive({
        info: store.state.user.info,
        orderData: {},
        goodList: [],
        loading: false,
        showCode:false,
        goodsItem:{},
        historyLength:0,
        columns: [
          {

            title: "批次名称",
            dataIndex: "product_batch_name",
            key: "product_batch_name"
          },
          {
            title: "商品编码",
            dataIndex: "product_sn",
            key: "product_sn"
          },
          {
            title: "商品信息",
            dataIndex: "gift_name",
            key: "gift_name",
            slots: { customRender: "gift_name" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "订单数量",
            dataIndex: "out_warehousing_num",
            key: "out_warehousing_num",
          },
          {
            title: "实发数量",
            dataIndex: "out_warehousing_real_num",
            key: "out_warehousing_real_num",
          }
        ]
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      let canvas = null; //二维码
      //获取详情
      const initData = async () => {
        const hide = message.loading("正在加载中...", 0);
        let res = await getOutWarehousingMore($route.query.id ).then((res) => res.data).catch(error => error);
            setTimeout(hide);
        if (iscode(res)) {
          // if((res.data.out_warehousing_status == 3 || res.data.out_warehousing_status == 2) && !state.columns.find(v=>v.title == '操作')){
          //   state.columns.push({
          //     title: "操作",
          //     key: "action",
          //     slots: { customRender: "action" }
          //   })
          // }
          state.orderData = res.data;
          //二维码
          canvas = qrcanvas({
            data:state.orderData.out_warehousing_sn,
            size:150,
          })
          if(res.data.out_warehousing_status == 1){
            document.getElementById('qrcode').innerHTML = '';
            document.getElementById('qrcode').appendChild(canvas);
          }
          
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      };
      //关闭订单
      const closeOrder = (id) => {
        $Modal.confirm({
          centered: true,
          title:'确定关闭订单？',
          content: h('div', {}, [
            h('p', '1、订单关闭后将无法开启'),
            h('p', '2、关闭订单后，商品移回原仓库，进行拆箱发货的中标和大标依然无效'),
          ]),
          onOk: async () => {
            let res = await closeRefundOrder($route.query.id).then((res) => res.data);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
      };
      
     

      onMounted(() => {
        initData();
        state.historyLength = window.history.length;
      });
      // 打印
      const printOrder=()=>{
        let oldStr = window.document.body.innerHTML; // 获取body的内容
        let start = "<!--startprint-->"; // 开始打印标识, 17个字符
        let end = "<!--endprint-->"; // 结束打印标识
        let newStr = oldStr.substr(oldStr.indexOf(start) + 17); // 截取开始打印标识之后的内容
        newStr = newStr.substring(0, newStr.indexOf(end)); // 截取开始打印标识和结束打印标识之间的内容
        window.document.body.innerHTML = newStr; // 把需要打印的指定内容赋给body
        window.print(); // 调用浏览器的打印功能打印指定区域
        window.document.body.innerHTML = oldStr; // body替换为原来的内容
        // window.print()
      }
      return {
        ...toRefs(state),
        closeOrder,
        printOrder
      };
    },
  };
</script>